import '../Inscription.less';
import { Badge, Input, Space ,Button,Radio,Card, Layout, Row, Col,notification,Modal, ConfigProvider, Table ,Comment, Avatar, Spin } from 'antd';
import { FileTextOutlined,FilePdfOutlined} from '@ant-design/icons';
import React, { Component } from "react";
import axios from "axios";
import moment from 'moment';
import es_ES from 'antd/lib/locale/es_ES';
import {getAuthors,getAuthorsStr,IP,countDownNotification, downloadFile, readFile} from '../components/utils';
import Foot from "../components/Footer"
import JuryMenu from "../components/JuryMenu"
import 'react-comments-section/dist/index.css'

class JuryHome extends Component {
  constructor(props){
    super(props)
    this.state={
      plays: 0,
      todayP: 0,
      todayC: 0,
      totalC: 0,
      totalP: 0 ,
      genres: {},
      conc_report:[],
      plays_report:[],
      currentRecordId:undefined,
      user:'',
      name:'',
      juryId:undefined,
      qualifications_dict:{},
      qualifications_changed:{},
      showCommentSection:false,
      comment:{},
      jurys_dict:{},
      edit_comment:undefined,
      selected_comment:undefined,
      comment_new_text:undefined,
      logued:false,
      loaded_table_data:false,
      new_comments:{},
      termsAccepted:false
    }
  }

  async componentWillMount() {
    const Moment = require('moment');
    //Jury    
    const response_jury= await fetch(IP + 'api/casa/jurado/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_jury = await response_jury.json();
    if(json_jury['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    const jury_user = localStorage.getItem("User")
    var current_jury = json_jury.filter(j=>j.usuario.toLowerCase() ==jury_user.toLowerCase() && j.premio == 4)[0]
    const jurys_dict={}
    Object.entries(json_jury).forEach(element => {
      jurys_dict[element[1].id]=element[1]
    });
    

    //Plays
    const plays = await fetch(IP + 'api/casa/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    const json_plays = await plays.json();
    var data_play = []
    var new_comments={}
    for(var i in json_plays){
      var item = json_plays[i];
      new_comments[item.id] = 0
      if(!current_jury || !current_jury.obras.includes(item.id)){
        continue
      }
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      const year = date.split('-')[2]
      
      var authorStr = getAuthorsStr(item.conc).join(", ")
      data_play.push(
          { 
              id : item.id,
              title : item.titulo,
              author: author ,
              authorStr:authorStr,
              date:date,
              pseudo: item.pseudonimo,
              code:year+'_'+item.genero+'_'+item.id,
              conc:item.conc,
              category:item.genero.nombre,
              pdf:item.pdf,
              edit:''
          });
    };

    //Qualifications
    var qual_url = new URL(IP + 'api/casa/calificacion/')
    var params = {jurado:current_jury.id}
    Object.keys(params).forEach(key => qual_url.searchParams.append(key, params[key]))
    const qualifications = await fetch(qual_url,{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    const json_qualifications = await qualifications.json()

    console.log(json_qualifications)
    const qualifications_dict={}
    json_qualifications.forEach(element => {
      qualifications_dict[element.obra] = element
    });

   
    //Comments access
    const last_comments_access_response = await fetch(IP + `api/casa/acceso_comentario/?jurado=${current_jury.id}`,{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_last_comments_access = await last_comments_access_response.json()
    const last_comments_access = {}
    json_last_comments_access.forEach(access => {
      last_comments_access[access.obra] = new Moment(access.fecha).format()
    });
    const comments = await fetch(IP + `api/casa/comentario/`,{ method: "get",
    credentials: "same-origin",
    headers: {
      "Authorization": localStorage.getItem("Authorization") ,
      "Accept": "application/json",
      "Content-Type": "application/json"}})
    const json_comments = await comments.json();
    json_comments.forEach(c=>{
      if(!last_comments_access[c.obra] || moment(c.fecha).isAfter(last_comments_access[c.obra])){
        new_comments[c.obra] =  new_comments[c.obra] + 1
      }
     
    })
    this.setState({plays:data_play,loaded_table_data:true, qualifications_dict:{...qualifications_dict}, jurys_dict:jurys_dict,user:jury_user,juryId:current_jury.id, name:current_jury.nombre_completo,logued:true, new_comments:new_comments})
  }

async acceptTerms(){
  var options = {
    method: "patch",
    credentials: "same-origin",
    headers: {
      "Authorization": localStorage.getItem("Authorization") ,
      "Accept": "application/json",
      "Content-Type": "application/json"},
  }
  var juryChanged={
    acepta_terminos: true,
  }
   
   await axios.patch(IP + `api/casa/jurado/${this.state.juryId}/`, juryChanged, options)
   .then(
     (response) => {
       if(response.status === 200){
        this.setState({termsAccepted:true},()=>countDownNotification(notification.success,'Bienvenido','','success'))
       }
        else{
          countDownNotification(notification.success,'Error','Hubo un error en la conexión, por favor intente más tarde','error')
        }
     },
     (error) => {
      notification.error({
        message:'Error',
        description:'Hubo un error, por favor revise los datos',
      })
     }
   ).catch((err) => 
    console.log(err)
   
   )
}
async getComments(playId){
  const comments = await fetch(IP + `api/casa/comentario/?obra=${playId.toString()}`,{ method: "get",
  credentials: "same-origin",
  headers: {
    "Authorization": localStorage.getItem("Authorization") ,
    "Accept": "application/json",
    "Content-Type": "application/json"}})
  const json_comments = await comments.json();
  const comments_dict = {}

  if(json_comments['detail']){
    notification.error({
      message:'Error',
      description:'Hubo un error cargando los comentarios, por favor intente más tarde',
    })
    return {}
  }
  else{
    json_comments.forEach(element => {
      comments_dict[element.id] = element
    });
    return comments_dict
  }

}
async postComment(play_id,parentComment){
  const data= new FormData()
  data.append('jurado',this.state.juryId)
  data.append('obra',play_id)
  data.append('texto',this.state.comment_new_text)
  if(parentComment){
    data.append('comentario_padre',parentComment)
  }
  axios.post(IP + 'api/casa/comentario/', data).then(async (res) => {
    if (res.status == 200){
      const comments_dict = await this.getComments(play_id)
      this.setState({comment:comments_dict,selected_comment:undefined,answer_comment:false, comment_new_text:''})
    } 
    }).catch((err) => {
      notification.error({
        message:'Error',
        description:"Hubo un error. Intente mas tarde por favor",
      });
  })
}

async saveEditComment(play_id,commentId){
  var options = {
    method: "patch",
    credentials: "same-origin",
    headers: {
      "Authorization": localStorage.getItem("Authorization") ,
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
  }
  var editedComment = {
    texto: this.state.comment_new_text
  }
  await axios.patch(IP + `api/casa/comentario/${commentId.toString()}/`, editedComment, options)
  .then(
    async(response) => {
     if(response.status === 200){
      var comments_dict = await this.getComments(play_id)
      this.setState({comment:comments_dict,edit_comment:false,selected_comment:undefined, comment_new_text:undefined},()=>countDownNotification(notification.success,'Completado','El mensaje se guardó de forma exitosa','success'))
     }
   
    },
    (error) => {
      console.log(error);
    }
  ).catch((err) => console.log(err))
}
async deleteComment(play_id,commentId){
  fetch(IP + `api/casa/comentario/${commentId.toString()}/`,{
    method:'DELETE',
    credentials: "same-origin",
    headers: {
      "Authorization": localStorage.getItem("Authorization") ,
      "Accept": "application/json",
      "Content-Type": "application/json"},
   
  }).then(async (res) => {
    if (res.status == 204){
      var comments_dict = await this.getComments(play_id)
      this.setState({comment:comments_dict},()=>countDownNotification(notification.success,'Completado','El mensaje se eliminó de forma exitosa','success'))
    } 
    }).catch((err) => {
      notification.error({
        message:'Error',
        description:"Hubo un error. Intente mas tarde por favor",
      });
  })
}
editComment(comment){
  this.setState({edit_comment:true,selected_comment:comment.id, comment_new_text:comment.texto})
}
cancelComment(){
  this.setState({edit_comment:false,selected_comment:undefined,answer_comment:false, comment_new_text:''})
}
answerComment(commentId){
  this.setState({selected_comment:commentId,answer_comment:true,edit_comment:false})
}

  getChildComments(comment){
    const { TextArea } = Input;
    return (this.state.edit_comment && this.state.selected_comment == comment.id &&
      <Comment
        actions={[<span onClick={()=>this.saveEditComment(comment.obra,comment.id)} >Guardar</span>, <span onClick={()=>this.cancelComment()} >Cancelar</span>]}
        avatar={
            <Avatar
              src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
              alt={this.state.jurys_dict[comment.jurado].nombre_completo}
            />
        }
        content={
          <TextArea value={this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
        }
      >
        {comment.respuestas.map(id => {
          return this.getChildComments(this.state.comment[id])
        })}
      </Comment>
         
      || (this.state.answer_comment && this.state.selected_comment == comment.id &&
        <Comment
          actions={comment.jurado==this.state.juryId ? [<span onClick={()=>this.editComment(comment)}>Editar</span>,<span onClick={()=>this.deleteComment(comment.obra, comment.id)} >Eliminar</span>,<span onClick={()=>this.answerComment(comment.id)} >Responder</span>]: [<span onClick={()=>this.answerComment(comment.id)}>Responder</span>]}
          author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
          avatar={
            <Avatar
              src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
              alt={this.state.jurys_dict[comment.jurado].nombre_completo}
            />
          }
          content={
            <p>
            {comment.texto}
            </p>
          }
          datetime={
              <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
          }
        >       
          <Comment
            actions={[<Button disabled={!this.state.comment_new_text || this.state.comment_new_text.replaceAll(/\s/g,'') === ""} type="primary" onClick={()=>this.postComment(this.state.currentRecordId,comment.id)} >Comentar</Button>, <Button type="text" onClick={()=>this.cancelComment()} >Cancelar</Button>]}
            avatar={
                  <Avatar
                    src={`https://ui-avatars.com/api/name=${this.state.name}&background=random`}
                    alt={this.state.name}
                  />
            }
            content={
              <TextArea placeholder="Escriba " value={this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
            }
          > 
          </Comment>
          {comment.respuestas.map(id => {
              return this.getChildComments(this.state.comment[id])
          })}
        </Comment>
      ) ||
      <Comment
        actions={comment.jurado==this.state.juryId ? [<span onClick={()=>this.editComment(comment)} key="comment-basic-edit-to">Editar</span>,<span  onClick={()=>this.deleteComment(comment.obra, comment.id)}  key="comment-basic-delete-to">Eliminar</span>,<span onClick={()=>this.answerComment(comment.id)}  key="comment-basic-reply-to">Responder</span>]: [<span onClick={()=>this.answerComment(comment.id)}  key="comment-basic-reply-to">Responder</span>]}
        author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
        avatar={
          <Avatar
            src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
            alt={this.state.jurys_dict[comment.jurado].nombre_completo}
          />
        }
        content={<p>{comment.texto}</p>}
        datetime={
          <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
        }
      >
        {comment.respuestas.map(id => {
          return this.getChildComments(this.state.comment[id])
        })}
      </Comment>
  )}
  async openComments(record){
    var comments_dict = await this.getComments(record.id)
    this.setState({showCommentSection:true, currentRecordId:record.id, comment:comments_dict})
  }
  async saveQualification(record_id){
    if (record_id in this.state.qualifications_changed){
      if(!(record_id in this.state.qualifications_dict)){//if it didn't exist, we have to post
        const data= new FormData()
        data.append('jurado',this.state.juryId)
        data.append('obra',record_id)
        data.append('puntaje',this.state.qualifications_changed[record_id])
        axios.post(IP + 'api/casa/calificacion/', data).then((res) => {
          countDownNotification(notification.success,'Completado','La calificación se guardó de forma exitosa','success')
        }).catch((err) => {
          notification.error({
            message:'Error',
            description:"Hubo un error. Intente mas tarde por favor",
          });
      })}
      else{//if it did exist, we have to patch
        var options = {
          method: "patch",
          credentials: "same-origin",
          headers: {
            "Authorization": localStorage.getItem("Authorization") ,
            "Accept": "application/json",
            "Content-Type": "application/json"},
        }
        var editedQualification = {
          puntaje: this.state.qualifications_changed[record_id]
        }
        await axios.patch(IP + `api/casa/calificacion/${this.state.qualifications_dict[record_id].id}/`, editedQualification, options)
        .then(
          (response) => {
           if(response.status === 200)
            countDownNotification(notification.success,'Completado','La calificación se guardó de forma exitosa','success')
          },
          (error) => {
            countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure")
          }
        ).catch((err) => countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure"))
      }
      var newqualifications_changed = {...this.state.qualifications_changed}
      delete newqualifications_changed[record_id]
      this.setState({qualifications_changed:{...newqualifications_changed}})
    }
  }
  render() {
    const { Content } = Layout;
    const { TextArea } = Input;
    const { Column, ColumnGroup } = Table;  
    const Moment = require('moment');

    const  closeComments=async ()=>{
      const data= new FormData()
      data.append('jurado',this.state.juryId)
      data.append('obra',this.state.currentRecordId)
      axios.post(IP + 'api/casa/acceso_comentario/', data).then(async (res) => {
        if (res.status == 200){
          console.log("OK")
        } 
        }).catch((err) => {
          console.log("ERROR")
      })
      const last_comments_access = await fetch(IP + `api/casa/acceso_comentario/?jurado=${this.state.juryId}`,{
        method: "get",
        credentials: "same-origin",
        headers: {
          "Authorization": localStorage.getItem("Authorization") ,
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
      });
      const json_last_comments_access = await last_comments_access.json()
      const last_comments_acces = {}
      json_last_comments_access.forEach(access => {
        last_comments_acces[access.obra] = new Moment(access.fecha).format()
      });
      const comments = await fetch(IP + `api/casa/comentario/`,{ method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"}})
      const json_comments = await comments.json();
      var new_comments = {}
      json_comments.forEach(c=>{
        if(!last_comments_acces[c.obra] || moment(c.fecha).isAfter(last_comments_acces[c.obra])){
          new_comments[c.obra] =  new_comments[c.obra]?  new_comments[c.obra] + 1 : 1
        }
      })
      this.setState({showCommentSection:false,editComment:false, selected_comment:undefined, new_comments:new_comments})
    }

    if(!this.state.logued)
      return(<div className="page-container">
              <div className = "content-wrap">
                <ConfigProvider locale={es_ES}>
                  <Layout style={{backgroundColor:'white'}}>
                    <Content>
                      <div style={{display:'block',top:'50%',right:'50%',position:'fixed'}}>
                        <Row  justify="center" align="middle">
                          <Col span={24}>
                              <Spin/>
                          </Col>   
                        </Row>         
                      </div>
                    </Content>
                  </Layout>
                </ConfigProvider>
              </div>
            </div>)
    else
        return (
          <div className="page-container">
            <div className = "content-wrap">
              <ConfigProvider locale={es_ES}>
              <Layout style={{backgroundColor:'white'}}>
                <JuryMenu defaultSelectedKey={"home"} name={this.state.name}/>
                <Content>
                  <Row  justify="center" align="middle" >
                    <Col span={24} >
                      <br></br>
                      <Card style={{backgroundColor:'#d9d9d9'}}>
                      <Table loading={!this.state.loaded_table_data} tableLayout='auto' dataSource={this.state.plays} pagination={false} size='small' style={{fontSize:'large'}} >
                        <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> Mis obras</div>}>
                          <Column 
                            title={(<div style={{ fontWeight:'bold', fontSize:'large'}} width={'10%'}>Título</div>)}
                            dataIndex="title"
                            key="title"
                            align='center'
                            render = {(text,record)=> {
                              return {
                                props: {
                                  style: { background:  "white",fontSize:'large',ellipsis:true }
                                },
                                children: <div>{text}</div>
                              }} }/>
                          <Column 
                            title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Seudónimo</div>)}
                            dataIndex="pseudo" key="pseudo" align='center'
                            render = {(text,record)=> {
                              return {
                                props: {
                                  style: { background:  "white",fontSize:'large',ellipsis:true }
                                },
                                children: <div>{text}</div>
                              }} }/>
                          <Column
                            dataIndex="pdf"
                            key="pdf"
                            align='center'
                            render = {(text,record)=> {
                              return {
                                props: {
                                  style: { background: "white",fontSize:'large',width:81 }
                                },
                                children:   <Button onClick={()=>readFile(text)}><FilePdfOutlined/> Leer</Button>
                              }} } />
                          <Column 
                            dataIndex="id"
                            key="id"
                            align='center'
                            render = {(text,record)=> {
                              return {
                                props: {
                                  style: { background:  "white",fontSize:'large',width:116 }
                                },
                                children:  <Button onClick={() => downloadFile(record)} ><FilePdfOutlined/>  Descargar</Button>
                              }} } />
                          <Column 
                            dataIndex="id" 
                            key="id"  
                            align='center'
                            render = {(text,record)=> {
                            return {
                              props: {
                                style: { background:  "white",fontSize:'large',width:173 }
                              },
                              children:  <div> <Badge size="small" count={this.state.new_comments[record.id]} overflowCount={100}>
                          <Button onClick={() => this.openComments(record)} ><FileTextOutlined />  Comentarios</Button></Badge></div>
                          }} } />
                          <Column
                            title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Calificación</div>)}
                            dataIndex="id"
                            key="id"
                            align='center'
                            render = {(text,record)=> {
                              return {
                                props: {
                                  style: { background:'#d9d9d9',fontSize:'large',width:399 }
                                },
                                children:   
                                  <Radio.Group 
                                    defaultValue={this.state.qualifications_dict[record.id]?this.state.qualifications_dict[record.id].puntaje:undefined}
                                    onChange={(event)=>{
                                      var new_qualifications={...this.state.qualifications_changed};
                                      new_qualifications[record.id]=event.target.value
                                      this.setState({qualifications_changed:{...new_qualifications}})}} 
                                    >
                                    <Space >
                                    <Radio style={{color:'red',borderBlockColor:'red'}} value={1}>Eliminada</Radio>
                                    <Radio style={{color:'#ffff80'}}  value={2}>Preseleccionada</Radio>
                                    <Radio disabled={!this.state.qualifications_dict[record.id] || this.state.qualifications_dict[record.id] && this.state.qualifications_dict[record.id].puntaje != 3} style={{color:'green',borderBlockColor:'green'}}  value={3}>Recomendada</Radio>
                                    </Space>
                                  </Radio.Group>
                              }}} />
                            <Column 
                              dataIndex="id"
                              key="id"
                              align='center'
                              render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:  "#d9d9d9",fontSize:'large',width:82 }
                                  },
                                  children:   
                                <Button disabled={!(text in this.state.qualifications_changed)} onClick={()=>this.saveQualification(text)}>Guardar</Button>
                                }} } />
                          </ColumnGroup>
                        </Table>
                      </Card>
                    </Col>                 
                  </Row>
                  { this.state.showCommentSection && 
                    <Modal
                      closable = {false}
                      title={ "Comentarios"}
                      visible={this.state.showCommentSection} 
                      width={580}
                      footer={[
                      
                          <Button key="backComment" onClick={closeComments}>
                          Cerrar
                          </Button>,
                        ]}
                      >
                        <Row align="middle" justify="center" >
                          <Col span={24}>
                            <Comment
                                actions={[<Button disabled={this.state.edit_comment || this.state.answer_comment || !this.state.comment_new_text || this.state.comment_new_text.replaceAll(/\s/g,'') === ""} type="primary" onClick={()=>this.postComment(this.state.currentRecordId)} >Comentar</Button>, <Button type="text" onClick={()=>this.cancelComment()} >Cancelar</Button>]}
                                avatar={
                                    <Avatar
                                      src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[this.state.juryId].nombre_completo}&background=random`}
                                      alt={this.state.jurys_dict[this.state.juryId].nombre_completo}
                                    />
                                }
                                content={
                                  <TextArea disabled={this.state.edit_comment || this.state.answer_comment} placeholder={"Añadir comentario"} value={!this.state.edit_comment && !this.state.answer_comment && this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
                                }
                              />
                            {
                              Object.entries(this.state.comment).map(element=>{
                                if (!element[1].comentario_padre){
                                  return this.getChildComments(element[1])
                                }
                              })
                            }
                          </Col>
                        </Row>
                      </Modal>}
                      <Modal //Modal to accept Terms
                        closable={false}
                        footer={[
                          <Button key="accept" onClick={()=>this.acceptTerms()}>
                          Aceptar
                          </Button>,
                        ]}
                        visible={!this.state.jurys_dict[this.state.juryId].acepta_terminos && !this.state.termsAccepted } 
                      >
                        <Row align="middle" justify="center" >
                          <Col span={24}>
                            <p>Si ha sido seleccionado como jurado y da su consentimiento, est&aacute; aceptando:</p>
                            <ol>
                            <li>Que recibir&aacute; las obras en concurso que sean puestas a su disposici&oacute;n en la p&aacute;gina <a href="https://premiocasa.cu/casa/jurado">https://premiocasa.cu/casa/jurado</a> identific&aacute;ndose con la contrase&ntilde;a que le sea suministrada por los administradores.</li>
                            <li>Que ser&aacute; depositario de esas obras y se abstendr&aacute; de utilizar las mismas para fines distintos o ajenos al concurso, quedando prohibida su comunicaci&oacute;n p&uacute;blica y cualquier acto de divulgaci&oacute;n de todo o parte de las mismas, con excepci&oacute;n de los intercambios entre los miembros del jurado con los que participe.</li>
                            <li>Que mantendr&aacute; total confidencialidad sobre los datos a los que tenga acceso por raz&oacute;n del concurso, as&iacute; como sobre las discusiones que en relaci&oacute;n con las obras se suscite.</li>
                            <li>Que una vez concluidas las deliberaciones y emitida el Acta del jurado, destruir&aacute; los archivos y datos sobre los autores que haya recibido para la realizaci&oacute;n de este encargo.</li>
                            </ol>
                          </Col>
                        </Row>
                      </Modal>
                </Content>
              </Layout>
            </ConfigProvider>
        </div>
      <Foot jury={true}/>
        </div>
        );
  }
}
export default JuryHome;


